import { __makeTemplateObject, __assign } from 'tslib';
import React__default from 'react';
import styled from 'styled-components';
import Button from '../Button/Button.js';
import { SIZES } from '../Button/constants.js';
var Wrapper = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  > :first-child {\n    z-index: 2;\n  }\n  > :nth-child(2) {\n    margin-left: -", "px;\n    z-index: 1;\n  }\n"], ["\n  display: flex;\n  > :first-child {\n    z-index: 2;\n  }\n  > :nth-child(2) {\n    margin-left: -", "px;\n    z-index: 1;\n  }\n"])), function (props) {
  return props.overlap;
});

var IconButton = function IconButton(props) {
  var W = (props.size ? SIZES[props.size] : props.height) || 0;
  return React__default.createElement(Wrapper, {
    overlap: 0.3 * W
  }, React__default.createElement(Button, __assign({}, props, {
    round: true
  }), props.icon), React__default.createElement(Button, __assign({}, props)));
};

var templateObject_1;
export { IconButton as default };